import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteProvider } from "@/context/SiteContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import WhatsAppModal from "@/components/WhatsAppModal";
import CookieConsent from "@/components/CookieConsent";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import LabuanPage from "@/pages/LabuanPage";
import MalaysiaServices from "@/pages/MalaysiaServices";
import GlobalExpansion from "@/pages/GlobalExpansion";
import InvestmentMigration from "@/pages/InvestmentMigration";
import CountriesIndex from "@/pages/CountriesIndex";
import CountryDetail from "@/pages/CountryDetail";
import About from "@/pages/About";
import Insights from "@/pages/Insights";
import InsightArticle from "@/pages/InsightArticle";
import Contact from "@/pages/Contact";
import Eligibility from "@/pages/Eligibility";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteProvider>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/labuan-company-setup" element={<LabuanPage />} />
              <Route path="/malaysia-business-services" element={<MalaysiaServices />} />
              <Route path="/global-business-expansion" element={<GlobalExpansion />} />
              <Route path="/business-investment-migration" element={<InvestmentMigration />} />
              <Route path="/countries" element={<CountriesIndex />} />
              <Route path="/countries/:slug" element={<CountryDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightArticle />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/eligibility" element={<Eligibility />} />
              <Route path="/legal/:slug" element={<Legal />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <FloatingWhatsApp />
          <WhatsAppModal />
          <CookieConsent />
          <Toaster position="top-center" richColors />
        </SiteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
